export default __webpack_public_path__ + "static/media/sd-srisaila-khandam.e963a859.png";